import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export function DefaultSidebar() {
  return (
    <Box>
      <Text size="md" fw={FONT_WEIGHTS.medium} c="white">
        Chat coming soon
      </Text>
    </Box>
  );
}
